import { Component, forwardRef, Input, OnInit, ViewChild } from "@angular/core";
import { GridComponent } from "@app/modules/shared/components/grid/grid.component";
import {
  ExplorerService,
  TabConfig,
} from "@app/modules/shared/services/explorer.service";
import { DynamicComponent } from "@app/data/dashboard/interfaces/dynamic-component.interface";
import { RolePermissionComponent } from "@dashboard/modules/management/role/components/role-permission/role-permission.component";
import { KlLoadingService } from "@app/modules/shared/services/kl-loading.service";
import { ApiService } from "@app/modules/shared/services/base/api.service";
import { UtilService } from "@app/modules/shared/services/util.service";

@Component({
  selector: "kl-user-role-list",
  templateUrl: "./role-list.component.html",
  styleUrls: ["./role-list.component.scss"],
})
export class RoleListComponent implements OnInit {
  @Input() tabId: string;
  @Input() modalId: string;
  @ViewChild(forwardRef(() => GridComponent), { static: true })
  gridComponent: any;
  dropdownActions = [
    {
      slug: "role_permissions",
      method: (cell) => {
        if (this.utilService.isShow(this.tabId + ".006")) {
          const copyData = JSON.parse(JSON.stringify(cell.item));
          const tabConfig = <TabConfig>{
            id: "roleAuth" + cell.item.id,
            title: "role_permissions",
            childTemplate: <DynamicComponent>{
              mode: "add",
              tabId: "roleAuth" + cell.item.id,
              template: RolePermissionComponent,
              dataContext: copyData,
              isReadOnly: false,
            },
            isCloseable: true,
          };
          this.explorerService.openTab(tabConfig);
        } else {
          this.handleError("not_authorized_to_perform_this_operation");
        }
      },
    },
  ];

  constructor(
    private explorerService: ExplorerService,
    private klLoadingService: KlLoadingService,
    private apiService: ApiService,
    private utilService: UtilService
  ) {}

  ngOnInit() {
    if (this.dropdownActions.length > 0) {
      this.gridComponent.actions = this.dropdownActions;
    }
  }

  handleError(error) {
    this.klLoadingService.hide();
    this.gridComponent.alertMessage = this.utilService.alertErrorMessage(error);
    this.gridComponent.alertType = "error";
    this.gridComponent.alertShow = true;
    this.gridComponent.cd.markForCheck();
  }
}
